import { stringify } from 'qs';

const reloadWindowWithParsedQueryString = (parsedQueryString: Object) => {
  const queryString = stringify(parsedQueryString, { addQueryPrefix: true }); // 自動判斷要不要加問號
  // reload window
  window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryString}`;
};

export default reloadWindowWithParsedQueryString;
